// prettier-ignore
import { anyone, adminOnly, nonParent } from './access_defs';
import buildGqlQuery from './buildGqlQuery';
import prependAcFn from './prependAcFn';

const buildToolkitsAccessQuery = (type) => buildGqlQuery(
	`toolkitsResource_${type}`,
	{ slug: 'String!' },
	`me { access { toolkitsResource(type: "${type}", slug: $slug) } }`,
);

export default prependAcFn(nonParent, {
	'toolkits/assignment-playlist': adminOnly,
	'toolkits/search-sim': adminOnly,
	'toolkits/search': anyone,
	'toolkits/alignments/[slug]': buildToolkitsAccessQuery('Alignment'),
	'toolkits/books/[slug]': buildToolkitsAccessQuery('Book'),
	'toolkits/games/[slug]': buildToolkitsAccessQuery('Game'),
	'toolkits/lessons/[slug]': buildToolkitsAccessQuery('Lesson'),
	'toolkits/library/[slug]': buildToolkitsAccessQuery('Page'),
	'toolkits/printables/[slug]': buildToolkitsAccessQuery('Printable'),
	'toolkits/units/[slug]': buildToolkitsAccessQuery('Unit'),
	'toolkits/videos/[slug]': buildToolkitsAccessQuery('Video'),
	'toolkits/[[...path]]': anyone,
});
